import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class HAssociationService {

  public memberInfo: any;

  constructor(
    private restful: RestfulService
  ) {
  }

  private extractData(res: Response) {
    let body = res;
    return body || [ ];
  }

  private handleErrorPromise(error: Response | any) {
    console.log(error.message || error);
    return Promise.reject(error.message || error);
  }

  // 정기 구독 정보 저장하기
  setAssociationSubscriptionSave( form: any ): Promise<any> {
    return this.restful.post({
        program: 'home',
        service: 'association',
        version: '1.0',
        action: 'setAssociationSubscriptionSave'
      }, form.value
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

}
